module.exports = __webpack_public_path__ + "img/eur.dbf22e39.svg";